import { render, staticRenderFns } from "./ModalFailHabilitation.vue?vue&type=template&id=89052e74"
import script from "./ModalFailHabilitation.vue?vue&type=script&lang=js"
export * from "./ModalFailHabilitation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports